import React from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'

const FullscreenImageBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-full-width ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <figure>
          <div className="figmedia" style={{ overflow: 'hidden' }}>
            <div data-rellax-center={true} data-rellax-speed={-3}>
              <Image
                className="img-fluid"
                image={block.image}
                alt={block.alt}
              />
            </div>
          </div>
          {block.caption?.length > 0 && (
            <figcaption>{block.caption}</figcaption>
          )}
        </figure>
      </section>
    </SbEditable>
  )
}

export default FullscreenImageBlock
